var map = {
	"./events-cat-cn.webp": 1928,
	"./events-cat.webp": 1929,
	"./games-cat.webp": 1930,
	"./live-casino-cat-cn.webp": 1931,
	"./live-casino-cat.webp": 1932,
	"./lottery-cat.webp": 1933,
	"./other-cat.webp": 1934,
	"./p2p-cat.webp": 1935,
	"./pd-table.webp": 1936,
	"./privacy-policy-title-bm.webp": 1937,
	"./privacy-policy-title-cn.webp": 1938,
	"./privacy-policy-title-id.webp": 1939,
	"./privacy-policy-title.webp": 1940,
	"./promos-1.webp": 1941,
	"./promos-2.webp": 1942,
	"./promos-3.webp": 1943,
	"./promos-4.webp": 1944,
	"./question.webp": 1945,
	"./sideBar-bg.webp": 1946,
	"./slot-cat-cn.webp": 1947,
	"./slot-cat.webp": 1948,
	"./special-cat-cn.webp": 1949,
	"./special-cat.webp": 1950,
	"./sports-cat-cn.webp": 1951,
	"./sports-cat.webp": 1952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;